
import { Nullable } from '@homeserve/od-typings/utils';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class WLStickySupportPhone extends Vue {
  public stickyPhoneBlock = false;
  private observer: Nullable<IntersectionObserver> = null;

  @Prop({ type: String, default: '01 70 82 17 82' })
  private supportPhoneNumber!: string;

  @Prop({ type: String, default: '#phone-sticky-layout' })
  private id!: string;

  mounted() {
    this.observer = new IntersectionObserver(
      entries => {
        const entry = entries[0];

        this.stickyPhoneBlock = entry.boundingClientRect.top + -280 + entry.boundingClientRect.height < 0;
      },
      { rootMargin: '-280px 0px 0px 0px' },
    );

    const rainbowDiv = document.querySelector(this.id);

    if (rainbowDiv) {
      this.observer.observe(rainbowDiv);
    }
  }
}
